import React from 'react';
import PropTypes from 'prop-types';
import BaseHeader from './BaseHeader';
import BaseBody from './BaseBody';
import classnames from 'classnames';
import { KeyCode, DateUtil } from '../util';

const DECADE_PREV_NEXT_CHANGE_NUM = 100;

function DecadeHeader(props){
    const {
        startYear,
        endYear,
        onPrevDecade,
        onNextDecade,
    } = props;

    return (
        <BaseHeader onSuperPrev={onPrevDecade} onSuperNext={onNextDecade}>
            <button className="picker-decade-title" disabled>{`${startYear} - ${endYear}`}</button>
        </BaseHeader>
    );
}

function DecadeBody(props){
    const { viewDate, renderCellContent } = props;
    let titleStartYear = DateUtil.getDecadeYearStart(viewDate);
    let bodyStartYear = DateUtil.addDecade(titleStartYear, -1);

    return (
        <BaseBody
            {...props}
            rowNum={DateUtil.DEFAULT_PANEL_BODY_TABLE_ROW_NUM}
            colNum={DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM}
            firstShowDate={bodyStartYear}
            renderCellContent={renderCellContent || DateUtil.getDecadeYear}
            calculateCellDate={DateUtil.addDecade}
        />
    );
}

class DecadePanel extends React.Component {
    onDecadeSelect = (date, event) => {
        const { onChange, picker, onSelect, onPanelChange } = this.props,
            startYear = DateUtil.getDecadeYearStart(date).getFullYear(),
            endYear = startYear + 9,
            currentYear = DateUtil.getNow().getFullYear();

        if(currentYear >= startYear && currentYear < endYear){
            date = DateUtil.getNow();
        }

        onSelect?.(date, 'decade');
        if(picker === 'decade'){
            onChange?.(date, event);
        } else {
            onPanelChange?.('year', date);
        }
    }

    onDecadeChange = diff => {
        const { viewDate, onPanelChange } = this.props;
        let newDate = DateUtil.addYear(viewDate, diff);
        onPanelChange?.('decade', newDate);
    }

    onKeyDown = e => {
        const { onSelect, viewDate, onChange } = this.props;
        // console.log('年范围面板的按键事件', e.keyCode);
        switch(e.keyCode){
            case KeyCode.LEFT:
                onSelect?.(DateUtil.addDecade(viewDate, -1), 'decade');
                break;
            case KeyCode.UP:
                onSelect?.(DateUtil.addDecade(viewDate, -DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM), 'decade');
                break;
            case KeyCode.RIGHT:
                onSelect?.(DateUtil.addDecade(viewDate, 1), 'decade');
                break;
            case KeyCode.DOWN:
                onSelect?.(DateUtil.addDecade(viewDate, DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM), 'decade');
                break;
            case KeyCode.ENTER:
                onSelect?.(viewDate, 'decade');
                onChange?.(viewDate, e);
                break;
            default:
                return true;
        }
        event.preventDefault();
        return false;
    }

    render() {
        const {
            viewDate,
            superNext,
            superPrev,
            panelWrapperProps,
        } = this.props;

        let startYear = DateUtil.getDecadeYearStart(viewDate).getFullYear();
        let endYear = startYear + 99;

        return (
            <div
                className={classnames({
                    "picker-panel-content": true,
                    "picker-decade-panel": true,
                })}
                {...panelWrapperProps}
            >
                <DecadeHeader
                    startYear={startYear}
                    endYear={endYear}
                    onPrevDecade={superPrev && this.onDecadeChange.bind(this, -DECADE_PREV_NEXT_CHANGE_NUM)}
                    onNextDecade={superNext && this.onDecadeChange.bind(this, DECADE_PREV_NEXT_CHANGE_NUM)}
                />
                <DecadeBody
                    {...this.props}
                    startYear={startYear}
                    onSelect={this.onDecadeSelect}
                />
            </div>
        );
    }
}

DecadePanel.PropTypes = {
    mode: PropTypes.string,
    onPanelChange: PropTypes.func,
    onViewDateChange: PropTypes.func,
    generateConfig: PropTypes.object,
    onSelect: PropTypes.func,
    onDateMouseEnter: PropTypes.func,
    onDateMouseLeave: PropTypes.func,
};

export default DecadePanel;